import {StrictMode} from 'react';
import {render} from '@wordpress/element';

/**
 * Import the stylesheet for the plugin.
 */
import {AppStoreProduct} from "./components/AppStoreProduct";

// Render the App component into the DOM
render(
    <StrictMode>
        <AppStoreProduct/>
    </StrictMode>
    , document.getElementById('shop-product-root')
);